import { useMemo } from 'react';

const getWorkFieldsOptions = ({ catalogs, workingSectorIdValue }) => {
  const parseOptions = ({ name, id }) => ({ label: name, id });
  const filterWorkingActivitiesBySector = ({ sectorId: id }) => (
    String(id) === workingSectorIdValue
  );
  const workingSectorOptions = catalogs?.workingSectors.map(parseOptions) || [];
  const workingActivitiesOptions = catalogs?.workingActivities
    .filter(filterWorkingActivitiesBySector)
    .map(parseOptions) || [];

  return {
    workingSectorOptions,
    workingActivitiesOptions,
  };
};

// this hook is not the same as the one in the work form from the credit module
// as this one does not contain the occupation options
export const useWorkOptions = ({
  workingSectorIdValue,
  catalogs,
}) => {
  const {
    workingSectorOptions,
    workingActivitiesOptions,
  } = useMemo(
    () => getWorkFieldsOptions({ catalogs, workingSectorIdValue }),
    [
      catalogs,
      workingSectorIdValue,
    ],
  );

  return {
    workingSectorOptions,
    workingActivitiesOptions,
  };
};
